import { useMutation } from '@tanstack/react-query';

import { useEndFlowModal } from '@/contexts/endFlowModalContext';

import { createManyAmenities } from '../functions/amenities';

export const useCreateManyAmenities = () => {
  const { showError } = useEndFlowModal();
  return useMutation({
    mutationKey: ['create-amenities'],
    mutationFn: createManyAmenities,
    onError: (e: any) => {
      showError({});
      console.error('Error creating amenities', e);
    }
  });
}
